import React, { useEffect, useState } from "react";
import axios from "../../../library/axios";
import { MySwal } from "../../../library/swal";
import { getApiErrorMessage } from "../../../helpers/apiErrorMessage";
import { useParams } from "react-router-dom";
import {
  FormEditScorePokjaComp,
  ScoreComp,
  FormScorePokjaComp,
  CreateChatComp,
  EditChatComp,
  AddDocumentSupportComp,
  EditDocumentSupportComp,
  FormScoreInternalComp,
  ScoreLipaComp,
  ScoreInternalComp,
} from "..";
import Modal from "react-bootstrap/Modal";
import {
  IconSquareRoundedCheck,
  IconArrowLeft,
  IconRepeat,
  IconChecklist,
} from "@tabler/icons-react";
// import { useNavigate } from "react-router-dom";
import { LoadingAtom } from "../../atoms";
import { setHrefWithSlugHook, useNavigateWithSlugHook, } from "../../../../src/config/routes/guards/slug";
import { getSlug, } from "../../../../src/config/routes/guards/slug";
import { notifyApiLoadError } from '../../../helpers/notifyApiError';

const InstrumentsComp = (props) => {
  const routeParams = useParams();

  const navigate = useNavigateWithSlugHook();
  const handleChangePage = (path) => {
    navigate(path);
  };

  const [isIdBabExist, setIsIdBabExist] = useState(false);
  const [babAccess, setBabAccess] = useState([]);
  const [logSelfAssessment, setLogSelfAssessment] = useState("NOT_SUBMIT");
  const [logPic, setLogPic] = useState("");
  const [logTime, setLogTime] = useState("");
  const [statusInNumber, setstatusInNumber] = useState(0);
  const [isPicPokja, setisPicPokja] = useState(true);
  const [loadClickStandard, setloadClickStandard] = useState(false);
  const [loadingInstrument, setloadingInstrument] = useState(false);
  const [showFormEditScorePokja, setshowFormEditScorePokja] = useState(false);
  const [showFormScorePokja, setshowFormScorePokja] = useState(false);
  const [showFormScoreInternal, setshowFormScoreInternal] = useState(false);
  const [showAddChat, setshowAddChat] = useState(false);
  const [showEditChat, setshowEditChat] = useState(false);
  const [showAddDocumentSupport, setshowAddDocumentSupport] = useState(false);
  const [showEditDocumentSupport, setshowEditDocumentSupport] = useState(false);
  const [idDocumentEdit, setidDocumentEdit] = useState(null);
  const [idUser, setidUser] = useState("");
  const [role, setRole] = useState("");
  const [idBab, setidBab] = useState("");

  const [urutanStandard, seturutanStandard] = useState(0);
  const [urutanElement, seturutanElement] = useState(0);

  const [countMasterEp, setcountMasterEp] = useState(0);
  const [countScoreAkreditasi, setcountScoreAkreditasi] = useState(0);

  const [scoreExisting, setScoreExisting] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [standards, setStandards] = useState([]);
  const [standard, setStandard] = useState({});
  const [elements, setElements] = useState([]);
  const [element, setElement] = useState({});
  const [skor, setSkor] = useState({});
  const [chat, setchat] = useState({});
  const [isSkorExist, setIsSkorExist] = useState(false);

  const fetchLog = async (idBabParam) => {
    try {
      const options = {
        url: `/logs/sa/${routeParams.id}/${idBabParam}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data.status)
      if (data.status !== undefined) {
        setLogSelfAssessment(data.status);
        setLogPic(data.namaLengkap);
        setLogTime(data.updatedAt);
      } else {
        setLogSelfAssessment("NOT_SUBMIT");
      }
    } catch (err) {
      console.log(err?.response?.data);
      MySwal.fire({
        icon: 'info',
        title: 'Oops, Error!',
        text: getApiErrorMessage(err),
      });
    }
  };

  const fetchOneAccreditation = async () => {
    try {
      const options = {
        url: `/accreditations/detailAccreditationParam/${routeParams.id}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setstatusInNumber(data.StatusInNumber);
    } catch (err) {
      console.log(err?.response?.data);
      MySwal.fire({
        icon: 'info',
        title: 'Oops, Error!',
        text: getApiErrorMessage(err),
      });
    }
  };

  const fetchOneUser = async () => {
    try {
      const options = {
        url: `/users/detailUser`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setidUser(data.data.id);
      setRole(data?.data?.mapping_user_groups[0]?.group?.namaGroup);
      // console.log(data?.data?.mapping_user_chapters)
      setBabAccess(data?.data?.mapping_user_chapters)
    } catch (err) {
      console.log(err?.response?.data);
      MySwal.fire({
        icon: 'info',
        title: 'Oops, Error!',
        text: getApiErrorMessage(err),
      });
    }
  };

  const fetchChapters = async () => {
    try {
      const options = {
        url: `/chapters/getListByFk/${routeParams.idMasterAkreditasi}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setChapters(data);
    } catch (err) {
      console.log(err?.response?.data);
      MySwal.fire({
        icon: 'info',
        title: 'Oops, Error!',
        text: getApiErrorMessage(err),
      });
    }
  };

  const fetchStandards = async (idBab, scoreExisting, keepPosition = false) => {
    try {
      const options = {
        url: `/elements/getListByFk/${idBab}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setStandards(data);

      if (data.length === 0) {
        setStandards([]);
        setElements([]);
        setloadingInstrument(false);
        setloadClickStandard(false);
        return;
      }

      // Pindah bab / muat awal selalu mulai dari standar pertama; refresh setelah
      // simpan (keepPosition) tetap di standar & EP yang sedang dibuka.
      const standardIndex =
        keepPosition && data[urutanStandard] !== undefined ? urutanStandard : 0;
      seturutanStandard(standardIndex);
      setStandard(data[standardIndex]);
      fetchElements(
        data[standardIndex].id,
        scoreExisting,
        keepPosition ? urutanElement : 0
      );
    } catch (err) {
      notifyApiLoadError(err, 'components/moleculs/chapters/instruments.fetchStandards');
    }
  };

  const fetchScoreExisting = async (idBab, keepPosition = false) => {
    try {
      const options = {
        url: `/skor/akreditasi-per-bab/${routeParams?.id}/${idBab}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      fetchStandards(idBab, data, keepPosition);
    } catch (err) {
      notifyApiLoadError(err, 'components/moleculs/chapters/instruments.fetchScoreExisting');
    }
  };

  const fetchCountEpByFk = async () => {
    try {
      const options = {
        url: `/variables/getCountEpByFk/${routeParams?.idMasterAkreditasi}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setcountMasterEp(data.count);
    } catch (err) {
      notifyApiLoadError(err, 'components/moleculs/chapters/instruments.fetchCountEpByFk');
    }
  };

  const fetchScoreAkreditasi = async () => {
    try {
      const options = {
        url: `/skor/count/${routeParams?.id}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data.length);
      // return false
      setcountScoreAkreditasi(data.length);
    } catch (err) {
      notifyApiLoadError(err, 'components/moleculs/chapters/instruments.fetchScoreAkreditasi');
    }
  };

  const fetchElements = async (param, scoreExisting, targetElementIndex = 0) => {
    const IdElement =
      param.length !== undefined ? param[urutanStandard].id : param;
    try {
      const options = {
        url: `/variables/getListByFk/${IdElement}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);

      setElements([]);
      data.map((d) =>
        scoreExisting.some(
          (se) => parseInt(se.idVariable) === parseInt(d.id)
        ) === true
          ? setElements((element) => [
            ...element,
            {
              isPokjaHasSubmitted:
                scoreExisting.find(
                  (se) => parseInt(se.idVariable) === parseInt(d.id)
                )?.isPokjaHasSubmitted !== null &&
                  scoreExisting.find(
                    (se) => parseInt(se.idVariable) === parseInt(d.id)
                  )?.isPokjaHasSubmitted !== undefined
                  ? true
                  : false,
              isScoreExist: true,
              isVerified:
                scoreExisting.find(
                  (se) => parseInt(se.idVariable) === parseInt(d.id)
                )?.skorSurveyor !== "" &&
                  scoreExisting.find(
                    (se) => parseInt(se.idVariable) === parseInt(d.id)
                  )?.skorSurveyor !== undefined
                  ? true
                  : false,
              Abjad: d.Abjad,
              Deskripsi: d.Deskripsi,
              IdElement: d.IdElement,
              id: d.id,
              Instrumen: d.Instrumen,
              IsDuring: d.IsDuring,
              IsLuring: d.IsLuring,
            },
          ])
          : setElements((element) => [
            ...element,
            {
              isPokjaHasSubmitted: false,
              isScoreExist: false,
              isVerified:
                scoreExisting.find(
                  (se) => parseInt(se.idVariable) === parseInt(d.id)
                )?.skorSurveyor !== "" &&
                  scoreExisting.find(
                    (se) => parseInt(se.idVariable) === parseInt(d.id)
                  )?.skorSurveyor !== undefined
                  ? true
                  : false,
              Abjad: d.Abjad,
              Deskripsi: d.Deskripsi,
              IdElement: d.IdElement,
              id: d.id,
              Instrumen: d.Instrumen,
              IsDuring: d.IsDuring,
              IsLuring: d.IsLuring,
            },
          ])
      );
      setScoreExisting(scoreExisting);

      if (data.length === 0) {
        setElement({});
        setIsSkorExist(false);
        setloadingInstrument(false);
        setloadClickStandard(false);
        return;
      }

      // Pertahankan EP yang sedang dibuka (mis. setelah simpan dari modal),
      // fallback ke EP pertama kalau index-nya sudah tidak ada.
      const selectedIndex = data[targetElementIndex] !== undefined ? targetElementIndex : 0;
      seturutanElement(selectedIndex);
      setElement(data[selectedIndex]);
      fetchSkor(data[selectedIndex].id);
    } catch (err) {
      notifyApiLoadError(err, 'components/moleculs/chapters/instruments.fetchElements');
    }
  };

  const fetchSkor = async (param) => {

    try {
      const options = {
        url: `/skor/skor-detail-param-by-idvariable/${param}/${routeParams.id}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data.data)
      setloadingInstrument(false);
      setloadClickStandard(false);
      if (data.code === 404) {
        setIsSkorExist(false);
      } else {
        setIsSkorExist(true);
        setSkor(data.data);
      }
    } catch (err) {
      notifyApiLoadError(err, 'components/moleculs/chapters/instruments.fetchSkor');
      setloadingInstrument(false);
      setloadClickStandard(false);
    }
  };

  const handleChangeChapter = (value) => {
    // console.log(value)
    // return false
    setloadingInstrument(true);
    setidBab(value);
    fetchScoreExisting(value);
    fetchScoreAkreditasi();
    fetchLog(value)

    const accessBab = babAccess.some(
      (item) => item.idBab === Number(value)
    );

    if (accessBab) {
      setIsIdBabExist(true)
    } else {
      setIsIdBabExist(false)
    }
  };

  useEffect(() => {
    validateAccreditation()
  }, []);

  const handleClickStandard = (standard, urutan) => {
    setloadClickStandard(true);
    seturutanStandard(urutan);
    seturutanElement(0);
    setStandard(standard);
    fetchElements(standard.id, scoreExisting, 0);
  };

  const handleClickElement = (element, urutan) => {
    seturutanElement(urutan);
    setElement(element);
    fetchSkor(element.id);
  };

  const handleEditScorePokja = (id) => {
    setshowFormEditScorePokja(true);
    fetchOneSkor(id);
  };

  const fetchOneSkor = async (idSkor) => {
    try {
      const options = {
        url: `/skor/skor-detail-param/${idSkor}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      setSkor(data);
    } catch (err) {
      notifyApiLoadError(err, 'components/moleculs/chapters/instruments.fetchOneSkor');
    }
  };

  const handleAfterSubmitScorePokja = () => {
    fetchSkor(element.id);
    fetchScoreExisting(idBab, true);
  };

  const handleEditChat = (chat) => {
    setshowEditChat(true);
    setchat(chat);
  };

  const handleEditDocument = (id) => {
    setidDocumentEdit(id);
    setshowEditDocumentSupport(true);
  };

  const handleDeleteDocument = (id) => {
    MySwal.fire({
      title: "Apakah anda yakin ?",
      text: "Dokumen akan di hapus permanen.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#26D07C",
      cancelButtonColor: "#191919",
      confirmButtonText: "Ya, Lakukan!",
      cancelButtonText: "Batal",
    }).then((result) => {
      if (result.isConfirmed) {
        axios({
          url: `/skor/delete-dokumen/${id}`,
          method: "DELETE",
          headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
        })
          .then((res) => {
            if (res.status === 200) {
              MySwal.fire({
                icon: "success",
                title: "Success",
                text: "Berhasil menghapus dokumen pendukung!",
              });

              fetchSkor(element.id);
            }
          })
          .catch((err) => {
            if (err !== "") {
              console.log(err?.response);
              MySwal.fire({
                icon: "error",
                title: "Oops, Error!",
                text: getApiErrorMessage(err),
              });
            }
          });
      }
    });
  };

  // const handleSubmitSelfAssessment = () => {
  //   MySwal.fire({
  //     title: "Apakah anda yakin ?",
  //     text: "Semua Pengisian Skor Elemen Penilaian pada Kegiatan ini akan di Kunci.",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#26D07C",
  //     cancelButtonColor: "#191919",
  //     confirmButtonText: "Ya, Lakukan!",
  //     cancelButtonText: "Batal",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       axios({
  //         url: `/accreditations/statusInNumber/${routeParams.id}`,
  //         method: "PATCH",
  //         data: {
  //           StatusInNumber: 1,
  //         },
  //         headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
  //       })
  //         .then((res) => {
  //           if (res.status === 200) {
  //             MySwal.fire({
  //               icon: "success",
  //               title: "Success",
  //               text: "Successfully Submit Self Assessment!",
  //             });
  //             setTimeout(() => {
  //               setHrefWithSlugHook(`/chapter/${routeParams.id}/${routeParams?.idMasterAkreditasi}`);
  //             }, 3000);
  //           }
  //         })
  //         .catch((err) => {
  //           if (err !== "") {
  //             console.log(err?.response);
  //             MySwal.fire({
  //               icon: "error",
  //               title: "Oops, Error!",
  //               text: getApiErrorMessage(err),
  //             });
  //           }
  //         });
  //     }
  //   });
  // };

  const handleSubmitBab = (statusSelfAssessment) => {
    MySwal.fire({
      title: "Apakah anda yakin ?",
      text: logSelfAssessment === "SUBMITED" ? "Semua Pengisian Skor Elemen Penilaian pada BAB ini akan di Rollback." : "Semua Pengisian Skor Elemen Penilaian pada BAB ini akan di Kunci.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#26D07C",
      cancelButtonColor: "#191919",
      confirmButtonText: "Ya, Lakukan!",
      cancelButtonText: "Batal",
    }).then((result) => {
      if (result.isConfirmed) {
        axios({
          url: `/skor/status-sa/${routeParams.id}`,
          method: "PATCH",
          data: {
            idBab: idBab,
            statusSelfAssessment: statusSelfAssessment,
          },
          headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
        })
          .then((res) => {
            if (res.status === 200) {
              if (statusSelfAssessment === "SUBMITED") {
                MySwal.fire({
                  icon: "success",
                  title: "Success",
                  text: "Successfully Submit Self Assessment!",
                });
              } else {
                MySwal.fire({
                  icon: "success",
                  title: "Success",
                  text: "Successfully Rollbacl Self Assessment!",
                });
              }

              setTimeout(() => {
                setHrefWithSlugHook(`/chapter/${routeParams.id}/${routeParams?.idMasterAkreditasi}`);
              }, 3000);
            }
          })
          .catch((err) => {
            if (err !== "") {
              console.log(err?.response);
              MySwal.fire({
                icon: "error",
                title: "Oops, Error!",
                text: getApiErrorMessage(err),
              });
            }
          });
      }
    });
  };

  const handleSubmitBabTdd = () => {
    MySwal.fire({
      title: "Apakah anda yakin ?",
      text: "Perubahan tidak bisa di ulang kembali, Semua Elemen Penilaian pada Bab ini akan menjadi TDD (Tidak Dapat Dinilai).",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#26D07C",
      cancelButtonColor: "#191919",
      confirmButtonText: "Ya, Lakukan!",
      cancelButtonText: "Batal",
    }).then((result) => {
      if (result.isConfirmed) {
        axios({
          url: `/skor/set-to-tdd`,
          method: "POST",
          data: {
            idKegiatanAkreditasi: routeParams.id,
            idBab: idBab,
          },
          headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
        })
          .then((res) => {
            if (res.status === 201) {
              MySwal.fire({
                icon: "success",
                title: "Success",
                text: "Chapter Successfully Set to TDD!",
              });
              setTimeout(() => {
                setHrefWithSlugHook(`/chapter/${routeParams.id}/${routeParams?.idMasterAkreditasi}`);
              }, 3000);
            }
          })
          .catch((err) => {
            if (err !== "") {
              console.log(err?.response);
              MySwal.fire({
                icon: "error",
                title: "Oops, Error!",
                text: getApiErrorMessage(err),
              });
            }
          });
      }
    });
  };

  const handleUnsubmitSelfAssessment = () => {
    MySwal.fire({
      title: "Apakah anda yakin ?",
      text: "Skor Elemen Penilaian pada Kegiatan ini akan terbuka untuk Kelompok Kerja.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#26D07C",
      cancelButtonColor: "#191919",
      confirmButtonText: "Ya, Lakukan!",
      cancelButtonText: "Batal",
    }).then((result) => {
      if (result.isConfirmed) {
        axios({
          url: `/accreditations/statusInNumber/${routeParams.id}`,
          method: "PATCH",
          data: {
            StatusInNumber: 0,
          },
          headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
        })
          .then((res) => {
            if (res.status === 200) {
              MySwal.fire({
                icon: "success",
                title: "Success",
                text: "Successfully Rollback Self Assessment!",
              });
              setTimeout(() => {
                setHrefWithSlugHook(`/chapter/${routeParams.id}/${routeParams?.idMasterAkreditasi}`);
              }, 3000);
            }
          })
          .catch((err) => {
            if (err !== "") {
              console.log(err?.response);
              MySwal.fire({
                icon: "error",
                title: "Oops, Error!",
                text: getApiErrorMessage(err),
              });
            }
          });
      }
    });
  };

  const validateAccreditation = () => {

    const requestBody = {
      id: routeParams.id,
      idMasterAkreditasi: routeParams.idMasterAkreditasi
    };

    axios({
      url: "/accreditations/validate",
      method: "POST",
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    })
      .then((res) => {
        if (res.status === 200) {
          fetchOneAccreditation();
          fetchChapters();
          fetchOneUser();
          fetchCountEpByFk();
        } else {
          MySwal.fire({
            icon: "error",
            title: "Oops, Error!",
            text:
              res?.data?.message ||
              "Permintaan tidak berhasil diproses server. Silakan coba lagi.",
          });
        }
      })
      .catch((err) => {
        if (err !== "") {
          console.log(err?.response?.data?.message);
          MySwal.fire({
            icon: "error",
            title: "Oops, Error!",
            text: getApiErrorMessage(err),
          });
        }
      });
  };

  // const isIdBabExist = babAccess.some(
  //   (item) => item.idBab === idBab
  // );

  // console.log(isIdBabExist)

  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="row col-12 mb-5">
            <div className="col-lg-5 col-12">
              <select
                className="form-select"
                onChange={(e) => handleChangeChapter(e.target.value)}
                value={idBab}
              >
                <option value="">- Pilih -</option>
                {chapters.map((chapter) => (
                  <option key={chapter.id} value={chapter.id}>
                    {chapter.Deskripsi} ({chapter.Singkatan})
                  </option>
                ))}
              </select>
            </div>
            <div className="col-lg-7 col-12" style={{ textAlign: "right" }}>

              {
                idBab !== ""
                  && role === "Surveior Internal"
                  && logSelfAssessment === "NOT_SUBMIT"
                  ?
                  <button
                    onClick={() => handleSubmitBabTdd()}
                    className="btn btn-sm btn-warning"
                    title="Jadikan Bab TDD"
                  >
                    <IconChecklist stroke={2} /> Set To TDD
                  </button>
                  :
                  idBab !== ""
                    && role === "Surveior Internal"
                    && logSelfAssessment === "SUBMITED"
                    ?
                    <button
                      className="btn btn-sm btn-secondary"
                      title="Jadikan Bab TDD"
                      disabled={true}
                    >
                      <IconChecklist stroke={2} /> Set To TDD
                    </button>
                    :
                    ""
              }

              {isIdBabExist && idBab !== "" && logSelfAssessment === "NOT_SUBMIT" &&
                role === "Kelompok Kerja" ? (
                <>
                  &nbsp;
                  <button
                    onClick={() => handleSubmitBab("SUBMITED")}
                    className="btn btn-sm btn-primary"
                    title="Submit Penilaian Mandiri"
                  >
                    <IconSquareRoundedCheck stroke={2} /> Submit
                  </button>
                </>

              ) : idBab !== "" && role === "Kelompok Kerja" ? (
                <>
                  &nbsp;
                  <button
                    className="btn btn-sm btn-secondary"
                    disabled={true}
                    title="Submit Penilaian Mandiri"
                  >
                    <IconSquareRoundedCheck stroke={2} /> Submit
                  </button>
                </>

              ) : (
                ""
              )}
              &nbsp;
              {idBab !== "" && logSelfAssessment === "SUBMITED" && role === "Surveior Internal" ? (
                <button
                  onClick={() => handleSubmitBab("NOT_SUBMIT")}
                  className="btn btn-sm btn-primary"
                  title="Rollback Penilaian Mandiri"
                >
                  <IconRepeat stroke={2} /> Rollback
                </button>
              ) : idBab !== "" && role === "Surveior Internal" ? (
                <button
                  className="btn btn-sm btn-secondary"
                  disabled={true}
                  title="Rollback Penilaian Mandiri"
                >
                  <IconRepeat stroke={2} /> Rollback
                </button>
              ) : (
                ""
              )}
              &nbsp;
              <button
                onClick={() => handleChangePage("/accreditation")}
                className="btn btn-sm btn-info"
              >
                <IconArrowLeft stroke={2} /> Kembali
              </button>
            </div>
          </div>
          {loadingInstrument === true ? (
            <LoadingAtom />
          ) : (
            <>
              {
                idBab && role !== "Surveior External" ?
                  <div className="row col-12 mb-4">
                    <span className="badge bg-dark">Status: {logSelfAssessment === "SUBMITED" ? `SUBMITED by ${logPic} |` : "NOT SUBMIT"} {logSelfAssessment === "SUBMITED" ? logTime : ""}</span>
                  </div>
                  :
                  ""
              }

              <div className="row col-12">
                {standards.length > 0 ? (
                  <>
                    <div className="col-lg-3 col-12">
                      {standards.map((standard, idx) => (
                        <div
                          key={idx}
                          onClick={() => handleClickStandard(standard, idx)}
                          className="card shadow-sm mb-1"
                          type="button"
                        >
                          <div className="card-body">
                            <h6>{standard.Nomor}</h6>
                            {/* <span className="badge badge-light-info">
                          <small>
                            Capaian PJ <b>{standard.Nomor}</b>: % | Internal: %
                          </small>
                        </span> */}
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  ""
                )}
                {elements.length > 0 && !loadClickStandard && (
                  <>
                    <div className="col-lg-4 col-12">
                      <div className="card card-bordered mb-1">
                        <div className="card-header ribbon ribbon-top">
                          <div className="ribbon-label bg-success">
                            {standard.Nomor}
                          </div>
                          <div className="card-title">
                            Standar Penilaian
                          </div>
                        </div>
                        <div className="card-body bg-success">
                          <h6 className="text-white">{standard.Deskripsi}</h6>
                        </div>
                      </div>

                      {elements.map((element, idx) => (
                        <div
                          key={idx}
                          className="card shadow-sm mb-1"
                          onClick={() => handleClickElement(element, idx)}
                        >
                          <div className="card-body">
                            <p>
                              <b>({element.Abjad}). </b>
                              {element.Deskripsi}
                            </p>

                            {role === "Kelompok Kerja" && (
                              <span className={`badge ${element.isScoreExist ? 'badge-light-success' : 'badge-light-danger'}`}>
                                {element.isScoreExist ? "Sudah Dinilai" : "Belum Dinilai"}
                              </span>
                            )}

                            {role === "Surveior Internal" && (
                              <span className={`badge ${element.isVerified ? 'badge-light-success' : 'badge-light-danger'}`}>
                                {element.isVerified ? "Sudah Diverifikasi" : "Belum Diverifikasi"}
                              </span>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>

                    {role === "Surveior External" ? (
                      <ScoreLipaComp
                        isSkorExist={isSkorExist}
                        element={element}
                        score={skor}
                      />
                    ) : role === "Surveior Internal" ? (
                      <ScoreInternalComp
                        isSkorExist={isSkorExist}
                        element={element}
                        handleFormScorePokja={() => setshowFormScorePokja(true)}
                        handleFormScoreInternal={() => setshowFormScoreInternal(true)}
                        handleEditScorePokja={handleEditScorePokja}
                        handleAddChat={() => setshowAddChat(true)}
                        handleEditChat={handleEditChat}
                        handleAddDocumentSupport={() => setshowAddDocumentSupport(true)}
                        handleDeleteDocument={handleDeleteDocument}
                        handleEditDocument={handleEditDocument}
                        score={skor}
                        statusInNumber={statusInNumber}
                        logSelfAssessment={logSelfAssessment}

                      />
                    ) : (
                      <ScoreComp
                        isSkorExist={isSkorExist}
                        element={element}
                        handleFormScorePokja={() => setshowFormScorePokja(true)}
                        handleFormScoreInternal={() => setshowFormScoreInternal(true)}
                        handleEditScorePokja={handleEditScorePokja}
                        handleAddChat={() => setshowAddChat(true)}
                        handleEditChat={handleEditChat}
                        handleAddDocumentSupport={() => setshowAddDocumentSupport(true)}
                        handleDeleteDocument={handleDeleteDocument}
                        handleEditDocument={handleEditDocument}
                        score={skor}
                        statusInNumber={statusInNumber}
                        logSelfAssessment={logSelfAssessment}
                        isIdBabExist={isIdBabExist}
                      />
                    )}
                  </>
                )}
              </div>
            </>
          )}
        </div>
      </div>

      <Modal
        show={showFormScorePokja}
        onHide={() => setshowFormScorePokja(false)}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Tambah Penilaian Mandiri{" "}
            <span className="text-info">
              {standard.Nomor}, EP:{element.Abjad}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormScorePokjaComp
            IdKegiatanAkreditasi={routeParams.id}
            IdBab={idBab}
            IdVariable={element.id}
            IdUser={idUser}
            fetch={handleAfterSubmitScorePokja}
            close={() => setshowFormScorePokja(false)}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={showFormEditScorePokja}
        onHide={() => setshowFormEditScorePokja(false)}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Edit Penilaian Mandiri{" "}
            <span className="text-info">
              {standard.Nomor}, EP:{element.Abjad}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormEditScorePokjaComp
            IdKegiatanAkreditasi={routeParams.id}
            IdBab={idBab}
            IdVariable={element.id}
            IdUser={idUser}
            fetch={handleAfterSubmitScorePokja}
            score={skor}
            element={element}
            close={() => setshowFormEditScorePokja(false)}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={showAddChat}
        onHide={() => setshowAddChat(false)}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Tambah Diskusi{" "}
            <span className="text-info">
              {standard.Nomor}, EP:{element.Abjad}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CreateChatComp
            IdKegiatanAkreditasi={routeParams.id}
            IdBab={idBab}
            IdVariable={element.id}
            IdUser={idUser}
            fetch={handleAfterSubmitScorePokja}
            close={() => setshowAddChat(false)}
            score={skor}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={showEditChat}
        onHide={() => setshowEditChat(false)}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Edit Diskusi{" "}
            <span className="text-info">
              {standard.Nomor}, EP:{element.Abjad}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditChatComp
            IdKegiatanAkreditasi={routeParams.id}
            IdBab={idBab}
            IdVariable={element.id}
            IdUser={idUser}
            fetch={handleAfterSubmitScorePokja}
            close={() => setshowEditChat(false)}
            score={skor}
            chat={chat}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={showAddDocumentSupport}
        onHide={() => setshowAddDocumentSupport(false)}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Tambah Dokumen{" "}
            <span className="text-info">
              {standard.Nomor}, EP:{element.Abjad}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddDocumentSupportComp
            IdKegiatanAkreditasi={routeParams.id}
            IdBab={idBab}
            IdVariable={element.id}
            IdUser={idUser}
            fetch={handleAfterSubmitScorePokja}
            close={() => setshowAddDocumentSupport(false)}
            score={skor}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={showEditDocumentSupport}
        onHide={() => setshowEditDocumentSupport(false)}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Edit Dokumen{" "}
            <span className="text-info">
              {standard.Nomor}, EP:{element.Abjad}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Dirender hanya saat modal terbuka supaya form selalu memuat
              ulang data dokumen dan tidak menyisakan isian lama. */}
          {showEditDocumentSupport ? (
            <EditDocumentSupportComp
              documentId={idDocumentEdit}
              fetch={handleAfterSubmitScorePokja}
              close={() => setshowEditDocumentSupport(false)}
            />
          ) : null}
        </Modal.Body>
      </Modal>

      <Modal
        show={showFormScoreInternal}
        onHide={() => setshowFormScoreInternal(false)}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Nilai Surveior Internal{" "}
            <span className="text-info">
              {standard.Nomor}, EP:{element.Abjad}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormScoreInternalComp
            IdKegiatanAkreditasi={routeParams.id}
            IdBab={idBab}
            IdVariable={element.id}
            IdUser={idUser}
            fetch={handleAfterSubmitScorePokja}
            close={() => setshowFormScoreInternal(false)}
            score={skor}
            element={element}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default InstrumentsComp;
